function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-948 -366)"
}, React.createElement("path", {
  d: "M2,18H12V16H2Zm11-5a1,1,0,0,1,1,1v5a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V6a1,1,0,0,1,.359-.769l6-5a1,1,0,0,1,1.282,0l6,5a1,1,0,1,1-1.282,1.538L7,2.3,2,6.469V14H12A1,1,0,0,1,13,13ZM6,6A1,1,0,1,1,7,7,1,1,0,0,1,6,6Z",
  transform: "translate(948 366)",
  fill: "#96a3af"
}), React.createElement("path", {
  d: "M2,18H12V16H2Zm11-5a1,1,0,0,1,1,1v5a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V6a1,1,0,0,1,.359-.769l6-5a1,1,0,0,1,1.282,0l6,5a1,1,0,1,1-1.282,1.538L7,2.3,2,6.469V14H12A1,1,0,0,1,13,13ZM6,6A1,1,0,1,1,7,7,1,1,0,0,1,6,6ZM19,9a1,1,0,0,1,0,2H17v2a1,1,0,0,1-2,0V11H13a1,1,0,0,1,0-2h2V7a1,1,0,0,1,2,0V9Z",
  transform: "translate(954 366)",
  fill: "#96a3af"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/upload-product.bb962084.svg";
export { SvgComponent as ReactComponent };